var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sandbox",
    d: "M0 2.43833C0 1.09144 1.09144 0 2.43833 0H19.5617C20.9086 0 22 1.09144 22 2.43833V19.5617C22 20.2084 21.7431 20.8286 21.2858 21.2858C20.8286 21.7431 20.2084 22 19.5617 22H2.43833C1.79165 22 1.17145 21.7431 0.714171 21.2858C0.256895 20.8286 0 20.2084 0 19.5617V2.43833ZM4.103 18.3333H18.1463C17.3588 17.2008 16.3088 16.2758 15.086 15.6373C13.8632 14.9988 12.5041 14.6658 11.1247 14.6667C9.74524 14.6658 8.38609 14.9988 7.16333 15.6373C5.94058 16.2758 4.89057 17.2008 4.103 18.3333ZM11 12.2222C11.5618 12.2222 12.118 12.1116 12.637 11.8966C13.156 11.6816 13.6276 11.3665 14.0248 10.9693C14.4221 10.5721 14.7372 10.1005 14.9522 9.58148C15.1671 9.06248 15.2778 8.50621 15.2778 7.94444C15.2778 7.38268 15.1671 6.82641 14.9522 6.30741C14.7372 5.78841 14.4221 5.31683 14.0248 4.9196C13.6276 4.52237 13.156 4.20727 12.637 3.99229C12.118 3.77731 11.5618 3.66667 11 3.66667C9.86546 3.66667 8.77739 4.11736 7.97515 4.9196C7.17292 5.72184 6.72222 6.80991 6.72222 7.94444C6.72222 9.07898 7.17292 10.1671 7.97515 10.9693C8.77739 11.7715 9.86546 12.2222 11 12.2222Z",
    fill: "#8D90A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeIcon);
export default __webpack_public_path__ + "static/media/typeIcon.4422bfce108d67d36e8c8904c7d655aa.svg";
export { ForwardRef as ReactComponent };